import {Component, Input} from '@angular/core';
import {CardComponent} from '../../card/card.component';
import {RouteConstants} from '../../../constants/route-constants';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  imports: [
    CardComponent,
    TranslatePipe
  ],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {
  @Input() error: ErrorConfig = {};
  @Input() loading = false;

  private _default = {
    headline: 'default.error404.headline',
    buttonLabelKey: 'default.error404.goToHome',
    buttonLink: [RouteConstants.routeHome],
    image: 'assets/img/illu_404.svg'
  }

  get config() {
    return {...this._default, ...this.error};
  }
}

export type ErrorConfig = {
  image?: string;
  imageUrl?: string;
  headline?: string;
  buttonLabelKey?: string;
  buttonLink?: string[];
}
